import { useKeycloak } from '@react-keycloak/web';
import { useEffect, useState } from 'react';
import { useHttpClient } from 'src/security/hooks/axiosProvider';

export const useProjects = () => {
  const [projects, setProjects] = useState([]);
  const httpClient = useHttpClient();
  const { keycloak } = useKeycloak();
  const [shouldRefetch, refetch] = useState({});
  const refetchProjects = () => refetch({});

  useEffect(() => {
    const fetchProjects = async () => {
      const isSuperAdmin = keycloak.hasResourceRole('ROLE_AGRISED_ADMIN_SUPER') ?? false;
      const userId = keycloak.tokenParsed.sub;
      const response = await httpClient.current?.get(`/api/project/all`);
      if (isSuperAdmin) {
        setProjects(response.data);
      } else {
        const filteredProjects = response.data.filter((project) => project.administrator.id === userId);
        setProjects(filteredProjects);
      }
    };
    fetchProjects();
  }, [httpClient, keycloak, shouldRefetch]);

  return { projects, refetchProjects };
};
